/// <reference types="./window.d.ts" />
/// <reference types="@types/gtag.js" />

import type { GaDefaultParams, GaEvent } from './types'

const EVENT_PREFIX = 'gw_'

/**
 * Sends an event to Google Analytics
 */
export function sendGaEvent(event: GaEvent) {
  const { event: eventName, ...params } = event

  //Adding prefix to event name for new GA4 integration
  const eventNameWithPrefix = `${EVENT_PREFIX}${eventName}`

  gtag('event', eventNameWithPrefix, params)
}

export function setGaDefaultParams(config: GaDefaultParams) {
  gtag('set', {
    user_id: config.user_id,
  })
}
